import { createSelector } from '@ngrx/store';
import { Order } from '../../../models';
import { AppState } from '../app.state';

export const selectActiveOrder = createSelector(
  (state: AppState) => state.order,
  (order: Order) => order
);
